import DataTable from 'react-data-table-component';
import './DataTable.css';

function TabDataTable() {
  const columns = [    { name: 'Name', selector: 'name' },    { name: 'Age', selector: 'age' },    { name: 'Location', selector: 'location' },  ];
  
  const data = [    { id: 1, name: 'John Smith', age: 32, location: 'New York' },    { id: 2, name: 'Jane Doe', age: 25, location: 'Los Angeles' },    { id: 3, name: 'Bob Johnson', age: 45, location: 'Chicago' },  ];
  
  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#007bff',
        color: '#fff',
        fontWeight: 'bold',
        padding: '10px',
        fontSize: '14px',
        textTransform: 'uppercase',
      }
    },
    cells: {
      style: {
        padding: '10px',
        fontSize: '14px',
      }
    },
    pagination: {
      style: {
        borderTop: '1px solid #ccc',
        padding: '10px',
        fontSize: '14px',
      }
    }
  };
  
  return (
    <DataTable columns={columns} data={data}
    pagination
    responsive
    customStyles={customStyles}
  />
  );
  }
  
  export default TabDataTable;
